import { split } from 'lodash';
import lodashIsEmpty from 'lodash/isEmpty';
import { toFromDates } from '../../Common/cleanDates';
import { isGFD } from '../../../actions/root_url';

export const desiredShapeByQuantity = (promotion) => {
  const {
    quantityFrom,
    quantityTo,
    discountValue,
    discountType,
    paymentTypeSelected,
    customerGroupSelected,
    methodSelected,
    startDateSelected,
    endDateSelected,
    selectedProduct,
    applyLv1,
    applyLv2,
    applyLv3,
    applyLv4,
    applyLv5,
    productSearchType,
    selectedGroup,
    selectedCategory,
    promotedPrice,
  } = promotion;
  let ViewablePriceLevelsArray = [];
  let ViewablePriceLevels = '';
  for (let i=0; i<5; i++) {
    if (promotion && promotion['applyLv' + (i+1)] === true) {
      ViewablePriceLevelsArray.push('PriceLv' + (i+1));
    }
  }
  ViewablePriceLevels = ViewablePriceLevelsArray.join(',');
  const { fromDate, toDate } = toFromDates(-1, startDateSelected, endDateSelected);
  if (productSearchType==='Group') {
    return {
      Method: 'ByQuantity',
      ProductGroup_id: selectedGroup,
      ProductCategory1_id: selectedCategory,
      StartDate: fromDate,
      EndDate: toDate,
      Group: customerGroupSelected,
      PaymentType: paymentTypeSelected,
      Qualification: methodSelected,
      FromQty: quantityFrom || 0,
      ToQty: quantityTo || 0,
      Off: discountValue || 0,
      IsPercent: (discountType === 'Percent'),
      ViewablePriceLevels: ViewablePriceLevels,
      PromotedPrice: promotedPrice,
    };
  }
  return {
    Method: 'ByQuantity',
    Product_id: selectedProduct.currentProdId,
    StartDate: fromDate,
    EndDate: toDate,
    Group: customerGroupSelected,
    PaymentType: paymentTypeSelected,
    Qualification: methodSelected,
    FromQty: quantityFrom || 0,
    ToQty: quantityTo || 0,
    Off: discountValue || 0,
    IsPercent: (discountType === 'Percent'),
    ViewablePriceLevels: ViewablePriceLevels,
    PromotedPrice: promotedPrice,
  };
};

export const desiredShapeBuyAGetB = (promotion) => {
  const {
    methodSelected,
    discountValue,
    discountType,
    paymentTypeSelected,
    customerGroupSelected,
    startDateSelected,
    endDateSelected,
    selectedProductA,
    selectedProductB,
    productQuantityA,
    productQuantityB,
    tabsKey,
    selectedProductMixA,
    Method,
    promotedPrice,
  } = promotion;
  const { fromDate, toDate } = toFromDates(-1, startDateSelected, endDateSelected);
  const payload = {
    Method: 'BuyAGetB',
    Product_id: selectedProductA.currentProdId,
    RelatedProduct_id: selectedProductB.currentProdId,
    StartDate: fromDate,
    EndDate: toDate,
    Group: customerGroupSelected,
    PaymentType: paymentTypeSelected,
    FromQty: Number(parseFloat(productQuantityA, 10).toFixed(2)) || 0,
    RelatedQuantity: Number(parseFloat(productQuantityB, 10).toFixed(2)) || 0,
    Qualification: methodSelected,
    Off: discountValue || 100,
    IsPercent: discountValue ? (discountType === 'Percent') : true,
    PromotedPrice: parseFloat(promotedPrice),
  };
  if (tabsKey === 'BuyMixAGetB' || Method === 'BuyMixAGetB') {
    payload.RelatedProduct_id = undefined;
    payload.ProductList = _.map(selectedProductMixA, p => {
      if (p.currentProdId) {
        return p.currentProdId;
      }
      return p.Product_id
    });
  }
  payload.IsPercent = false;
  payload.Off = 0;
  return payload;
};

export const desiredShapeByTotalPriceProduct = (promotion) => {
  const {
    paymentTypeSelected,
    customerGroupSelected,
    startDateSelected,
    endDateSelected,
    selectedProduct,
    minPurchasePrice,
    productQuantityB,
    promoCode,
    autoApply,
    SalesType,
  } = promotion;
  const { fromDate, toDate } = toFromDates(-1, startDateSelected, endDateSelected);
  return {
    Method: 'ByTotalPriceProduct',
    Product_id: selectedProduct.currentProdId,
    StartDate: fromDate,
    EndDate: toDate,
    Group: customerGroupSelected,
    PaymentType: paymentTypeSelected,
    MinPurchase: minPurchasePrice,
    RelatedQuantity: Number(parseFloat(productQuantityB, 10).toFixed(2)) || 0,
    Off: 100,
    IsPercent: true,
    PromoCode: promoCode,
    AutoApply: autoApply,
    SalesType: SalesType,
  };
};

export const desiredShapeByTotalPriceDiscount = (promotion) => {
  const {
    promoCode,
    discountValue,
    discountType,
    paymentTypeSelected,
    customerGroupSelected,
    startDateSelected,
    endDateSelected,
    minPurchasePrice,
    autoApply,
    IsOneTime,
    IsPublic,
    SalesType,
  } = promotion;
  const { fromDate, toDate } = toFromDates(-1, startDateSelected, endDateSelected);
  return {
    Method: 'ByTotalPriceDiscount',
    PromoCode: promoCode,
    AutoApply: autoApply,
    IsOneTime: IsOneTime,
    IsPublic: IsPublic,
    StartDate: fromDate,
    EndDate: toDate,
    Group: customerGroupSelected,
    PaymentType: paymentTypeSelected,
    MinPurchase: minPurchasePrice,
    Off: discountValue || 0,
    IsPercent: (discountType === 'Percent'),
    SalesType: SalesType,
  };
};

export const cleanProduct = product => (
  {
    inStock: product.InStock,
    purchased: product.Purchased,
    presale: product.PreSale,
    netWeight: product.NetWeight,
    shipWeight: product.NetWeight,
    priceLv1: product.PriceLv1,
    priceLv2: product.PriceLv2,
    priceLv3: product.PriceLv3,
    priceLv4: product.PriceLv4,
    priceLv5: product.PriceLv5,
    currentRefPrice: isGFD ? product.warehouse_inventory__RefPrice : product.RefPrice,
    currentProdId: product.Product_id,
    currentProdName: product.Name,
    currentProdNum: product.ProductNum,
    currentProductDescription: product.Description,
    currentRefNum: product.RefNum,
    currentUnitType: product.ProductType,
    currentPackageSize: product.PackageSize,
    currentProductWeight: product.NetWeight,
    currentProductCRV: product.CRV,
    currentProductTaxable: String(product.isTaxable),
    posUnitPrice: product.warehouse_inventory__POSUnitPrice ? product.warehouse_inventory__POSUnitPrice : product.POSUnitPrice,
  }
);

export const populateFields = (state, promotion) => {
  const {
    FromQty,
    ToQty,
    Off,
    IsPercent,
    PaymentType,
    Group,
    Qualification,
    StartDate,
    EndDate,
    RelatedQuantity,
    MinPurchase,
    PromoCode,
    Product,
    RelatedProduct,
    AutoApply,
    IsOneTime,
    IsPublic,
    SalesType,
    ViewablePriceLevels,
    ProductGroup_id,
    ProductCategory1_id,
    ProductListDetails,
    Method,
    PromotedPrice,
  } = promotion;
  console.log('promotion promotion', promotion)
  let splitArray = [];
  let outputArray = [false, false, false, false, false];
  if (ViewablePriceLevels) {
    splitArray = ViewablePriceLevels.split(',');
  }
  splitArray.map(r=>{
    if (r === 'PriceLv1') {
      outputArray[0] = true;
    }
    if (r === 'PriceLv2') {
      outputArray[1] = true;
    }
    if (r === 'PriceLv3') {
      outputArray[2] = true;
    }
    if (r === 'PriceLv4') {
      outputArray[3] = true;
    }
    if (r === 'PriceLv5') {
      outputArray[4] = true;
    }
  })
  const product = (Product) ? cleanProduct(Product) : {};
  const relatedProduct = (RelatedProduct) ? cleanProduct(RelatedProduct) : {};
  let calculatePriceProduct = relatedProduct.currentProdId ? relatedProduct : product;
  let promotedPrice = calculatePromotedPrice({
    discount: (Off) ? Off.toFixed(2) : '', 
    product: calculatePriceProduct,
    paymentTypeSelected: PaymentType || '',
    discountType: (IsPercent) ? 'Percent' : 'Dollar',
  });
  if (isGFD) {
    promotedPrice = PromotedPrice
  }
  return {
    ...state,
    quantityFrom: FromQty || '',
    quantityTo: ToQty || '',
    discountValue: (Off) ? Off.toFixed(2) : '',
    discountType: (IsPercent) ? 'Percent' : 'Dollar',
    paymentTypeSelected: PaymentType || '',
    customerGroupSelected: Group || '',
    methodSelected: Qualification || '',
    startDateSelected: new Date(StartDate) || undefined,
    endDateSelected: new Date(EndDate) || undefined,
    productQuantityA: FromQty || '',
    productQuantityB: RelatedQuantity || '',
    selectedProduct: product || {},
    selectedProductA: product || {},
    selectedProductB: relatedProduct || {},
    minPurchasePrice: (MinPurchase) ? MinPurchase.toFixed(2) : '0',
    promoCode: PromoCode || '',
    autoApply: AutoApply,
    IsOneTime: IsOneTime,
    IsPublic: IsPublic,
    SalesType: SalesType,
    applyLv1: outputArray[0],
    applyLv2: outputArray[1],
    applyLv3: outputArray[2],
    applyLv4: outputArray[3],
    applyLv5: outputArray[4],
    selectedGroup: ProductGroup_id || '',
    selectedCategory: ProductCategory1_id || '',
    ...(ProductGroup_id ? {productSearchType: 'Group'} : {}),
    promotedPrice,
    selectedProductMixA: ProductListDetails,
    tabsKey: Method,
  };
};

const getTwoDecimal = (number) => {
  return  Math.trunc(number*100)/100
}

const calculatePromotedPrice = ({
  discount, product, paymentTypeSelected, discountType
}) => {
  // on discount change calcualate promoted price
  let promotedPrice = "";
  if (discountType === 'Dollar') {
    if (paymentTypeSelected === 'POS') {
      promotedPrice = getTwoDecimal(product.posUnitPrice - discount)
    } else {
      promotedPrice = getTwoDecimal(product.currentRefPrice - discount)
    }
  } else {
    // Percentage
    if (paymentTypeSelected === 'POS') {
      console.log('calculatePromotedPrice', product, discount);
      promotedPrice = getTwoDecimal(product.posUnitPrice * (100 - discount)/100)
    } else {
      promotedPrice = getTwoDecimal(product.currentRefPrice * (100 - discount)/100)
    }
  }
  return promotedPrice
}

export const clearForm = state => (
  {
    ...state,
    selectedProduct: {},
    selectedProductA: {},
    selectedProductB: {},
    suggestValue: '',
    suggestValueA: '',
    suggestValueB: '',
    methodSelected: '',
    quantityFrom: '',
    quantityTo: '',
    discountValue: '',
    discountType: 'Dollar',
    productQuantityA: '',
    productQuantityB: '',
    minPurchasePrice: '',
    promoCode: '',
    autoApply: false,
    IsOneTime: false,
    IsPublic: false,
  }
);

export const isIncompleteForm = (state, type) => {
  const {
    startDateSelected,
    endDateSelected,
    customerGroupSelected,
    paymentTypeSelected,
    methodSelected,
    selectedProduct,
    selectedGroup,
    selectedCategory,
    quantityFrom,
    quantityTo,
    discountValue,
    selectedProductA,
    selectedProductB,
    productQuantityA,
    productQuantityB,
    minPurchasePrice,
    selectedProductMixA,
  } = state;
  if (!startDateSelected
    || !endDateSelected
    || !customerGroupSelected
    || !paymentTypeSelected
  ) {
    return true;
  }
  
  if (type === 'ByQuantity') {
    return (
      (lodashIsEmpty(selectedProduct) && selectedGroup==='')
      || !methodSelected
      || !discountValue
      || !quantityFrom
    );
  } else if (type === 'BuyAGetB') {
    return (
      lodashIsEmpty(selectedProductA)
      || lodashIsEmpty(selectedProductB)
      || !productQuantityA
      || !productQuantityB
      || !methodSelected
      // || !discountValue
    );
  } else if (type === 'ByTotalPriceProduct') {
    return (
      lodashIsEmpty(selectedProduct)
      || !minPurchasePrice
      || !productQuantityB
    );
  } else if (type === 'ByTotalPriceDiscount') {
    return (
      !minPurchasePrice
      || !discountValue
    );
  } else if (type === 'BuyMixAGetB') {
    return (
      lodashIsEmpty(selectedProductMixA)
      // || lodashIsEmpty(selectedProductB)
      || !productQuantityA
      || !methodSelected
    );
  }
  return false;
};



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/utils.js